<script lang="ts">
	const testimonial = {
		quote:
			"Heyweek does what it promises. Time tracking, tasks, client management, reporting. It's all there and it actually connects together. For a distributed consultancy, that coherence matters a lot.",
		author: 'Robert Blixt',
		role: 'Founder',
		company: 'Zivrio',
		logo: '/logos/zivrio.png',
		slug: 'zivrio'
	};
</script>

<section class="section">
	<div class="container">
		<div class="inner">
			<a href="/stories/{testimonial.slug}" class="card">
				<div class="card__quote-mark" aria-hidden="true">"</div>
				<p class="card__text">{testimonial.quote}</p>
				<footer class="card__footer">
					<img src={testimonial.logo} alt="{testimonial.company} logo" class="card__logo" />
					<div class="card__author">
						<strong>{testimonial.author}</strong>
						<span>{testimonial.role}, {testimonial.company}</span>
					</div>
					<div class="card__cta">
						Read story
						<svg
							width="13"
							height="13"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2.5"
							stroke-linecap="round"
							stroke-linejoin="round"
							aria-hidden="true"
						>
							<line x1="5" y1="12" x2="19" y2="12"></line>
							<polyline points="12 5 19 12 12 19"></polyline>
						</svg>
					</div>
				</footer>
			</a>

			<a href="/customers" class="all-stories">
				Customer stories
				<svg
					width="13"
					height="13"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2.5"
					stroke-linecap="round"
					stroke-linejoin="round"
					aria-hidden="true"
				>
					<line x1="5" y1="12" x2="19" y2="12"></line>
					<polyline points="12 5 19 12 12 19"></polyline>
				</svg>
			</a>
		</div>
	</div>
</section>

<style>
	.section {
		padding-block: var(--space-20);
		background: var(--bg-primary);
	}

	.container {
		max-width: 1100px;
		margin-inline: auto;
		padding-inline: var(--container-padding, 1.5rem);
	}

	.inner {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-5);
	}

	/* Card */
	.card {
		display: block;
		max-width: 600px;
		width: 100%;
		padding: var(--space-8);
		background: var(--bg-secondary);
		border: 1px solid var(--border-light);
		border-radius: var(--radius-xl);
		text-decoration: none;
		position: relative;
	}

	.card:hover {
		border-color: hsl(var(--brand-h) var(--brand-s) var(--brand-l) / 0.35);
		box-shadow: 0 8px 32px hsl(var(--brand-h) var(--brand-s) var(--brand-l) / 0.08);
	}

	.card__quote-mark {
		font-size: 4rem;
		line-height: 1;
		color: var(--text-brand);
		opacity: 0.25;
		font-family: Georgia, serif;
		margin-bottom: var(--space-2);
		display: block;
	}

	.card__text {
		font-size: var(--font-size-lg);
		font-weight: var(--font-weight-medium);
		line-height: 1.65;
		color: var(--text-primary);
		font-style: italic;
		margin-bottom: var(--space-6);
	}

	.card__footer {
		display: flex;
		align-items: center;
		gap: var(--space-3);
	}

	.card__logo {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		object-fit: cover;
		flex-shrink: 0;
	}

	.card__author {
		display: flex;
		flex-direction: column;
		gap: 1px;
		flex: 1;
	}

	.card__author strong {
		font-size: var(--font-size-sm);
		font-weight: var(--font-weight-semibold);
		color: var(--text-primary);
		font-style: normal;
	}

	.card__author span {
		font-size: var(--font-size-xs);
		color: var(--text-secondary);
		font-style: normal;
	}

	.card__cta {
		display: inline-flex;
		align-items: center;
		gap: var(--space-1);
		font-size: var(--font-size-xs);
		font-weight: var(--font-weight-semibold);
		color: var(--text-brand);
		white-space: nowrap;
	}

	/* Link below card */
	.all-stories {
		display: inline-flex;
		align-items: center;
		gap: var(--space-1);
		font-size: var(--font-size-sm);
		color: var(--text-secondary);
		text-decoration: none;
	}

	.all-stories:hover {
		color: var(--text-primary);
	}
</style>
